module.exports = __webpack_public_path__ + "img/cf_yellow.6532cbb4.svg";